import { Component, EventEmitter, Inject, Injectable, Input, Output } from '@angular/core';

import { Environment, LanguageKey } from '@s2a/core';

@Injectable()
@Component({
  selector: 's2a-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent {
  @Output() languageChanged = new EventEmitter();

  @Input() selectedLanguageKey = LanguageKey.EN;

  title = 'components.language_selection.title';
  languages = [];

  constructor(@Inject(Environment) private environment) {
    // S2ACN-5983: CN deployment keeps only English and Chinese
    this.languages = [
      {
        key: LanguageKey.EN,
        description: 'English',
        imageUrl: `${this.environment.imageUrl}img/flags/${LanguageKey.EN}.png`,
      },
      {
        key: LanguageKey.CN,
        description: '中文',
        imageUrl: `${this.environment.imageUrl}img/flags/${LanguageKey.CN}.png`,
      },
    ];
  }

  /**
   * S2ACN-5983: users with a removed language (DE/RU/ES/FR/PT/IT/PL) still
   * stored as their preference fall back to English instead of showing no
   * selected language at all.
   */
  get displayedLanguageKey(): LanguageKey {
    const isSupported = this.languages.some((language) => language.key === this.selectedLanguageKey);

    return isSupported ? this.selectedLanguageKey : LanguageKey.EN;
  }

  onClick(key: LanguageKey, index: number): void {
    this.selectedLanguageKey = key;
    const event = new CustomEvent('language-selected-event', {
      detail: {
        languageKey: this.selectedLanguageKey,
        description: this.languages[index].description,
      },
      bubbles: true,
      composed: true, // allows bubbling across the boundary between shadow DOM and regular DOM
    });
    document.dispatchEvent(event);
  }
}
